import { z, zCoercedBoolean } from '@harvestiq/zod';
import {
  CoverageTiers,
  RmaLrpCommodityCodes,
  RmaLrpTypeCodes,
} from '@harvestiq/constants';
import { zCalendarDate, zDecimalRequired } from '@harvestiq/zod';

export const downloadLrpQuoteRequestSchema = z.object({
  commodityCode: z.nativeEnum(RmaLrpCommodityCodes),
  typeCode: z.nativeEnum(RmaLrpTypeCodes),
  numberOfHead: z.coerce.number(),
  marketingMonths: z.array(z.coerce.number()),
  targetSalesEffectiveDate: zCalendarDate().optional(),
  endDate: zCalendarDate().optional(),
  targetWeight: zDecimalRequired(),
  coverageTier: z.nativeEnum(CoverageTiers),
  isPre2026BeginningFarmerRancher: zCoercedBoolean().optional(),
  isVeteranFarmerRancher: zCoercedBoolean().optional(),
  beginningFarmerRancherCropYearCount: z.coerce
    .number()
    .int()
    .nullable()
    .optional(),
});

export type DownloadLrpQuoteRequest = z.input<
  typeof downloadLrpQuoteRequestSchema
>;

export const downloadLrpQuoteResponseItemSchema = z.object({
  filename: z.string(),
  salesEffectiveDate: zCalendarDate(),
});

export type DownloadLrpQuoteResponseItem = z.infer<
  typeof downloadLrpQuoteResponseItemSchema
>;

export const downloadLrpQuoteResponseSchema = z
  .object({
    data: z.array(downloadLrpQuoteResponseItemSchema),
  })
  .or(
    z.object({
      message: z.string(),
    })
  );

export type DownloadLrpQuoteResponse = z.infer<
  typeof downloadLrpQuoteResponseSchema
>;
